






























































import { defineComponent } from '@nuxtjs/composition-api';
import useSearchInsights from '@shared/composables/useSearchInsights';
import analytics from '@shared/helpers/analytics';
import getIPXUrl from '@shared/helpers/getIPXUrl';
import { BaseButton, BaseLink, BaseProductCard } from '@shared/ui';

export default defineComponent({
  name: 'MiniProductCard',
  components: {
    BaseProductCard,
    BaseButton,
    BaseLink,
  },
  props: {
    productId: {
      type: String,
      default: '',
    },
    objectId: {
      type: String,
      default: '',
    },
    queryId: {
      type: String,
      default: '',
    },
    position: {
      type: Number,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    sku: {
      type: String,
      default: '',
    },
    partNumber: {
      type: String,
      default: '',
    },
    variantId: {
      type: String,
      required: true,
    },
    hasVariants: {
      type: Boolean,
      required: true,
    },
    image: {
      type: [Array, Object, String],
      default: '',
    },
    price: {
      type: Number,
      required: true,
    },
    compareToPrice: {
      type: Number,
      default: null,
    },
    link: {
      type: String,
      required: true,
    },
    brandLink: {
      type: String,
      default: '',
    },
    vendor: {
      type: [String, Object],
      default: '',
    },
    imageWidth: {
      type: [Number, String],
      default: null,
    },
    imageHeight: {
      type: [Number, String],
      default: null,
    },
    colors: {
      type: Array,
      default: () => [],
    },
    showAddToCartButton: {
      type: Boolean,
      default: false,
    },
    isAddedToCart: {
      type: Boolean,
      deafult: false,
    },
    addToCartDisabled: {
      type: Boolean,
      default: false,
    },
    imageTag: {
      type: String,
      default: 'nuxt-img',
    },
    nuxtImgConfig: {
      type: Object,
      default: () => ({}),
    },
    ctaButton: {
      type: Boolean,
      default: false,
    },
    ctaButtonText: {
      type: String,
      default: '',
    },
    fromSearchBarResults: {
      type: Boolean,
      default: false,
    },
    fallbackImageSrcWidth: {
      type: Number,
      default: 130,
    },
  },
  // eslint-disable-next-line max-lines-per-function
  setup(props) {
    const { eventProductClicked } = useSearchInsights();

    const fallBackImageSrc = getIPXUrl('amx-logo.svg', props.fallbackImageSrcWidth);

    const product: any = {
      variantId: props.variantId,
      id: props.productId,
      name: props.name,
      vendor: props.vendor,
    };

    const selectItemAnalytics = () => {
      analytics({
        event: 'select_item',
        product,
        discount: props.compareToPrice,
        price: props.price,
      });

      if (props.objectId && props.position && props.queryId) {
        eventProductClicked({
          objectId: props.objectId,
          position: props.position,
          queryId: props.queryId,
        });
      }
    };

    return {
      product,
      fallBackImageSrc,
      selectItemAnalytics,
    };
  },
  computed: {
    isOnSale(): boolean {
      return !!this.compareToPrice && this.compareToPrice > this.price;
    },
    regularPricePrefixText(): string {
      if (this.isOnSale) {
        return '';
      }

      return '';
    },
    compareToPriceSuffixText(): string {
      if (this.isOnSale) {
        return `Save $${Math.round((this.compareToPrice - this.price) * 100) / 100}`;
      }

      return '';
    },
  },
});
